import React from 'react';
import {
  BsArrowRepeat,
  BsCheckCircleFill,
  BsFileEarmarkExcel,
  BsFiletypeCsv,
  BsFileEarmarkText,
  BsTrash3,
} from 'react-icons/bs';
import styles from './SelectedFileCard.module.scss';

const FILE_TYPE_BY_EXTENSION = {
  xlsx: {
    icon: BsFileEarmarkExcel,
    iconColor: 'var(--success-600)',
    label: 'Excel Spreadsheet',
  },
  xls: {
    icon: BsFileEarmarkExcel,
    iconColor: 'var(--success-600)',
    label: 'Excel Spreadsheet',
  },
  csv: {
    icon: BsFiletypeCsv,
    iconColor: 'var(--success-600)',
    label: 'CSV File',
  },
};

const getFileTypeInfo = (fileName) => {
  const extension = fileName.split('.').pop()?.toLowerCase();
  return (
    FILE_TYPE_BY_EXTENSION[extension] || {
      icon: BsFileEarmarkText,
      iconColor: 'var(--gray-500)',
      label: 'File',
    }
  );
};

const formatFileSize = (bytes) => {
  if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};

/**
 * Summary card for a file the user has selected for upload — icon, name,
 * type/size, a status line, and Replace/Remove actions. Derives its
 * display info from the File object itself so callers don't need to pass
 * type/size separately.
 */
export const SelectedFileCard = ({
  file,
  statusText = 'Uploaded successfully',
  onReplace,
  onRemove,
}) => {
  const { icon: FileIcon, iconColor, label } = getFileTypeInfo(file.name);

  return (
    <div className={styles.selectedFileCard}>
      <div className={styles.fileIconWrap}>
        <FileIcon size={24} color={iconColor} />
      </div>
      <div className={styles.fileInfo}>
        <span className={styles.fileName}>{file.name}</span>
        <span className={styles.fileMeta}>
          {label} &bull; {formatFileSize(file.size)}
        </span>
        <span className={styles.fileStatus}>
          <BsCheckCircleFill size={13} />
          {statusText}
        </span>
      </div>
      <div className={styles.fileActions}>
        <button type="button" className={styles.replaceBtn} onClick={onReplace}>
          <BsArrowRepeat size={14} />
          Replace File
        </button>
        <button type="button" className={styles.removeBtn} onClick={onRemove}>
          <BsTrash3 size={14} />
          Remove
        </button>
      </div>
    </div>
  );
};
